module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-asa.7662b9ab.png";